import Http from './base-http'

class ForgetPassword extends Http {
  forgotPasswordVerificationLink(email) {
    return this.client.post('/forgotpassword', email)
  }
}

const forgetPassword = new ForgetPassword({
  modelUrlPrefix : 'site'
})

export default forgetPassword
